/*global google*/
import React from 'react'
 
import ServerProperties from '../../../../config/server.js'
/*import SearchSuggestion from './RenderAutoSuggest.js'*/
const { MarkerWithLabel } = require("react-google-maps/lib/components/addons/MarkerWithLabel");
const {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
} = require("react-google-maps");

export default class JobMap extends React.Component {
	constructor(){
		super()

		// this.location  	= null
		this.location = {
			lat: -43.525650, 
			lng: 172.639847
		}
		this.queryTemp 	= ''
		this.nIdx 		= 0
		this.siteData 	= []
		this.loaded 	= false
	}

	componentWillReceiveProps(nextProps){
		if(nextProps.self.state.siteData[0] !== undefined){
			if(this.loaded === false){
				// this.state = {
					this.location = {
						lat: parseFloat(nextProps.self.state.siteData[0].Latitude),
						lng: parseFloat(nextProps.self.state.siteData[0].Longitude)
					}
				// }
				this.loaded = true
			}
		}
	}

	shouldComponentUpdate(nextProps, nextState){
		if(nextProps.self.state.findedData.length > 0 && (nextProps.self.query !== '') && nextProps.self.state.dontRender === false){
			// console.log('hit A')
			if (this.queryTemp.includes(nextProps.self.query) ){
				if(this.nIdx < nextProps.self.state.findedData.length - 1){
					this.nIdx += 1	
				}else{
					this.nIdx = 0	
				}
				// console.log('idx a1: '+nIdx)
				this.location = {
					lat: parseFloat(nextProps.self.state.findedData[this.nIdx].Latitude),
					lng: parseFloat(nextProps.self.state.findedData[this.nIdx].Longitude)
				}
			}else{
				// console.log('hit B')
				this.queryTemp 	= nextProps.self.query
				this.nIdx 		= 0 
				this.location 	= {
					lat: parseFloat(nextProps.self.state.findedData[this.nIdx].Latitude),
					lng: parseFloat(nextProps.self.state.findedData[this.nIdx].Longitude)
				}
			}
		}
		return true	
	}

	render(){
		return(
			<MapWithAMarker
				mapdata={this.props.self}
				coordinate={this.location}
				googleMapURL={ServerProperties.GOOGLE_MAP.API+'&libraries=geometry,drawing,places'}
				loadingElement={<div style={{ height: 100 }} />}
				containerElement={<div style={{ height: '100vh'}} />}
				mapElement={<div style={{ height: '100%', width:'100%' }} />}
			/>
		)
	}
}

const MapWithAMarker = withScriptjs(withGoogleMap(props => (
			<GoogleMap
			    defaultZoom={14}
			    center={props.coordinate}
			>
				{(props.mapdata.state.siteData.length > 0) ? props.mapdata.state.siteData.map((val,index) => {
					let animation = null
					let y = 60
					let x = (val.Name.length + (val.Name.length * 2)) + (val.Name.length * 0.7)
					if(parseFloat(val.Latitude)===props.coordinate.lat && parseFloat(val.Longitude)===props.coordinate.lng){
						animation = google.maps.Animation.BOUNCE
						y = 0
					}
					//console.log(animation)
					return(
						<MarkerWithLabel
							key={index}
							position={{ lat: parseFloat(val.Latitude), lng: parseFloat(val.Longitude) }}
							onClick={()=>props.mapdata.toggleModalDetail(val)}
							labelAnchor= {new google.maps.Point(x, y)}
							labelStyle={{fontSize:'15px',fontWeight:'bold',textShadow:'0px 0px 5px white'}}
							animation = {animation}
						>
							<div>{val.Name}</div>
						</MarkerWithLabel>
					)
				}) : null}
			</GoogleMap>
		)
	)
)


// WEBPACK FOOTER //
// ./src/App/topmenu/job/helper/component/JobMap.js